module.exports = __webpack_public_path__ + "static/media/navy-faces.673153aa.png";